import axios from 'axios';

// export const baseURL= 'http://192.168.0.125:9595';

// export const baseURL= 'http://localhost:9595';

export const baseURL= 'https://api.kanadx.com/';

export const httpClient = axios.create({
    baseURL,
});

export default httpClient;
